/* eslint-disable max-classes-per-file */
import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';

// this is useful for cases where you want to filter out null, or undefined,
// but not all falsy values, like 0 for example
// Replace
// expr == null
// with
// expr | isNil
@Pipe({
  name: 'isNil',
})
export class IsNilPipe implements PipeTransform {
  transform<T>(
    value: T | null | undefined,
  ): value is null | undefined {
    return isNil(value);
  }
}

// this is useful for cases where you want to filter out null, or undefined,
// but not all falsy values, like 0 for example
// Replace
// expr != null
// with
// expr | isNotNil
@Pipe({
  name: 'isNotNil',
})
export class IsNotNilPipe implements PipeTransform {
  transform<T>(
    value: T | null | undefined,
  ): value is T {
    return !isNil(value);
  }
}
